import React from "react"
import { Link } from "gatsby"

class Menu extends React.Component {
  render() {
    const item = {
      display: "table-cell",
      verticalAlign: "middle",
    }
    const activeStyle = { color: "#46e" }

    return (
      <header>
        <ul
          id="menu"
          style={{
            display: "table",
            tableLayout: "fixed",
            textAlign: "center",
            width: "100%",
            marginLeft: 0,
            marginBottom: 0,
            backgroundColor: "#181818",
            color: `white`,
          }}
        >
          <li style={item}>
            <Link to="/" activeStyle={activeStyle}>
              Home
            </Link>
          </li>
          <li style={item}>
            <Link
              to="/blog/about/"
              activeStyle={activeStyle}
              partiallyActive={true}
            >
              About
            </Link>
          </li>
          <li style={item}>
            <Link
              to="/blog/archive/"
              activeStyle={activeStyle}
              partiallyActive={true}
            >
              Archive
            </Link>
          </li>
          <li style={item}>
            <Link
              to="/blog/categories/"
              activeStyle={activeStyle}
              partiallyActive={true}
            >
              Category
            </Link>
          </li>

        </ul>
      </header>
    )
  }
}

export default Menu
